export default __webpack_public_path__ + "static/media/croped_img1.a6f78f73.jpeg";